module.exports = __webpack_public_path__ + "img/home-pic-2.c5879954.jpg";